import { t } from '@lingui/macro';
import styled from 'styled-components/macro';

import { Link, ParagraphMd } from '@olist/design-system';
import { tokens } from '@olist/design-system-tokens';

import { getOlistUrl, getPrivacyPolicyURL } from 'helpers/i18n';
import useMixPanel from 'hooks/use-mixpanel';

const FooterLayout = styled.footer`
  display: flex;
  justify-content: space-between;
  padding: ${tokens.spacing[700]} ${tokens.spacing[1100]};
  width: 100%;
  hr {
    display: none;
  }

  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    margin-top: ${tokens.spacing[900]};
    margin-bottom: ${tokens.spacing[1200]};

    hr {
      width: 100%;
      position: relative;
      top: -24px;
      display: block;
    }
  }
`;

const TextWithLink = styled(ParagraphMd)`
  @media (max-width: 720px) {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    margin-bottom: ${tokens.spacing[600]};
  }
`;

type EventPrefix = {
  [key: string]: string;
};

const eventPrefix: EventPrefix = {
  '/auth/login': 'Sign in - ',
  '/auth/request-recovery': 'Request Recovery - ',
  '/auth/request-recovery-sent': 'Request Recovery Sent - ',
  '/auth/reset-password': 'Reset Password - ',
  '/auth/reset-password-success': 'Reset Password Success - ',
  '/auth/reset-password-invalid': 'Reset Password Invalid - ',
};

const getEventPrefix = () => {
  return eventPrefix[window.location.pathname] || '';
};

function Footer() {
  const { track } = useMixPanel(false);
  const thisYear = new Date().getFullYear();

  return (
    <FooterLayout>
      <hr />
      <TextWithLink>
        <Link
          href={getOlistUrl()}
          target="_blank"
          type="inline"
          onClick={() => track(`${getEventPrefix()}Clicked on Olist Home`)}
        >
          olist.com
        </Link>
        &nbsp;© {thisYear}&nbsp;{t`All rights reserved`}
      </TextWithLink>
      <Link
        href={getPrivacyPolicyURL()}
        target="_blank"
        onClick={() => track(`${getEventPrefix()}Clicked on Privacy policy`)}
      >
        {t`privacy policy`}
      </Link>
    </FooterLayout>
  );
}

export default Footer;
